import { Chip, type IconName } from "@narmi/design_system";

type ChipKind = React.ComponentProps<typeof Chip>["kind"];

export type StatusDefinition = {
  key: string;
  kind: ChipKind;
  startIcon: IconName;
  labelKey: string;
  descriptionKey: string;
};

// WIRE + ACH statuses
export const WIRE_AND_ACH_STATUS_DEFINITIONS: StatusDefinition[] = [
  {
    key: "pending_approval",
    kind: "warn",
    startIcon: "hourglass",
    labelKey: "file-import-status-label-pending-approval",
    descriptionKey: "file-import-status-desc-pending-approval",
  },
  {
    key: "processing",
    kind: "info",
    startIcon: "clock",
    labelKey: "file-import-status-label-processing",
    descriptionKey: "file-import-status-desc-processing",
  },
  {
    key: "partially_completed",
    kind: "error",
    startIcon: "info",
    labelKey: "file-import-status-label-completed-with-issues",
    descriptionKey: "file-import-status-desc-completed-with-issues",
  },
  {
    key: "completed",
    kind: "success",
    startIcon: "check",
    labelKey: "file-import-status-label-completed",
    descriptionKey: "file-import-status-desc-completed",
  },
  {
    key: "failed",
    kind: "error",
    startIcon: "info",
    labelKey: "file-import-status-label-failed",
    descriptionKey: "file-import-status-desc-failed",
  },
  {
    key: "canceled",
    kind: "error",
    startIcon: "info",
    labelKey: "file-import-status-label-canceled",
    descriptionKey: "file-import-status-desc-canceled",
  },
];

// ACH ONLY statuses
export const ACH_ONLY_STATUS_DEFINITIONS: StatusDefinition[] = [
  {
    key: "scheduled",
    kind: "info",
    startIcon: "clock",
    labelKey: "file-import-status-label-scheduled",
    descriptionKey: "file-import-status-desc-scheduled",
  },
  {
    key: "in_progress",
    kind: "info",
    startIcon: "clock",
    labelKey: "file-import-status-label-in-progress",
    descriptionKey: "file-import-status-desc-in-progress",
  },
];

export const CONSUMER_WIRE_STATUS_DEFINITIONS: StatusDefinition[] = [
  {
    key: "pending",
    kind: "warn",
    startIcon: "hourglass",
    labelKey: "transaction-pending-tag",
    descriptionKey: "wire-status-desc-pending",
  },
  {
    key: "processing",
    kind: "info",
    startIcon: "clock",
    labelKey: "file-import-status-label-processing",
    descriptionKey: "wire-status-desc-processing",
  },
  {
    key: "scheduled",
    kind: "info",
    startIcon: "clock",
    labelKey: "file-import-status-label-scheduled",
    descriptionKey: "wire-status-desc-scheduled",
  },
  {
    key: "completed",
    kind: "success",
    startIcon: "check",
    labelKey: "file-import-status-label-completed",
    descriptionKey: "wire-status-desc-completed",
  },
  {
    key: "failed",
    kind: "error",
    startIcon: "info",
    labelKey: "file-import-status-label-failed",
    descriptionKey: "wire-status-desc-failed",
  },
  {
    key: "canceled",
    kind: "error",
    startIcon: "info",
    labelKey: "file-import-status-label-canceled",
    descriptionKey: "wire-status-desc-canceled",
  },
];
